import { getActivityStatus } from './displayStatus';
import {userTypes} from "Constants/constants";
import * as Sentry from '@sentry/browser';

export function promiseTimeout(promise, ms){

  // Create a promise that rejects in <ms> milliseconds
  let timeout = new Promise((resolve, reject) => {
    let id = setTimeout(() => {
      clearTimeout(id);
      reject(new Error('Timed out in '+ ms + 'ms.'));
    }, ms)
  })

  // Returns a race between our timeout and the passed in promise
  return Promise.race([
    promise,
    timeout
  ])
}
export function formatAREAScore(score, long=false, veryshort=false){ // TODO pass these props more cleanly
  let years = Math.floor(score);
  let months = Math.round((score - years) * 12);
  if(long){
    return (years + " year, " + months + " month");
  }
  if(veryshort) {
    return(years + "y, " + months + "m");
  }
  return(years + " y, " + months + " m");
}

// TODO dedup this function
export function uuidToHEX(value){
  if (value.length < 30 && !isNaN(Number(value))) {
    // If the value is a number and less than 30 characters, it is an OID and not UUID. Return as is.
    return value;
  }

  const pattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  if(pattern.test(value)){
    value = value.replace(/\-/g, '').toUpperCase();
  }
  return value;
}

export function formatGuidForSIS(guid){
  if (guid.length < 30 && !isNaN(Number(guid))) {
    // If the value is a number and less than 30 characters, it is an OID and not UUID. Return as is.
    return guid;
  }
  
  let formattedGuid = guid.toLowerCase();

  //Check for valid UUID and fix if not
  const pattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  if(pattern.test(formattedGuid) === false){
    formattedGuid = formattedGuid.replace(/(\w{8})(\w{4})(\w{4})(\w{4})(\w{12})/, "$1-$2-$3-$4-$5");
  }
  return formattedGuid;
}

export function makeStringPosessive(nameString){
  return nameString + (nameString[nameString.length -1] == 's' ? "'" : "'s");
}

//arrToSort - [Array]
//asc - [Boolean]
// order the activities by status. Completed first, then errors, then processing, then assigned
export function sortByStatus(arrToSort, asc){
  let result = arrToSort.sort((element1, element2) => {
    let status1 = element1.assessmentStatus ? element1.assessmentStatus.id : getActivityStatus(element1).id;
    let status2 = element2.assessmentStatus ? element2.assessmentStatus.id : getActivityStatus(element2).id;
    if (status1 == status2) {
      if(element1.updatedAt && element2.updatedAt){
        return element2.updatedAt - element1.updatedAt;
      }else if(element1.date && element2.date) {
        return new Date(element1.date).getTime() - new Date(element2.date).getTime();
      }
    } else if(status1 == "ERROR"){
      return -1;
    } else if(status1 == "ABORTED" && status2 != "ERROR"){
      return -1;
    } else if(status1 == "COMPLETE" && status2 != "ERROR" && status2 != "ABORTED"){
      return -1;
    } else if(status1 == "RESCORED" &&  status2 != "ERROR" && status2 != "ABORTED" && status2 != "COMPLETE"){
      return -1;
    } else if(status1 == "SCORING" &&  status2 != "ERROR" && status2 != "ABORTED" && status2 != "COMPLETE" && status2 != "RESCORED"){
      return -1;
    } else if(status1 == "IN_PROGRESS" &&  status2 != "ERROR" && status2 != "ABORTED" && status2 != "COMPLETE" && status2 != "RESCORED" && status2 != "SCORING"){
      return -1;
    } else if(status1 == "ASSIGNED" &&  status2 != "ERROR" && status2 != "ABORTED" && status2 != "COMPLETE" && status2 != "RESCORED" && status2 != "SCORING" && status2 != "IN_PROGRESS"){
      return -1;
    } else if(status1 == "UNASSESSED" &&  status2 != "ERROR" && status2 != "ABORTED" && status2 != "COMPLETE" && status2 != "RESCORED" && status2 != "SCORING" && status2 != "IN_PROGRESS" && status2 != "ASSIGNED"){
      return -1;
    } else {
      return 1;
    }
  });

  return asc ? result : result.reverse();
}

// takes an array of activity objects and returns that array sorted by date created, most recent first
export function sortActivitiesByDate(activities){
  let compare = function (activity1,activity2) {
    let date1 = new Date(activity1.updatedAt);
    let date2 = new Date(activity2.updatedAt);
    if (date1.getTime() < date2.getTime()){
      return 1;
    } else if (date1.getTime() > date2.getTime()){
      return -1;
    } else {
      return 0;
    }
  }
  return activities.sort(compare);
}

//sort activities by descending createdAt date
export function sortActivitiesByCreatedDate(activities){
  return activities.sort((a, b) => {
    const aDate = new Date(a.createdAt || 0);
    const bDate = new Date(b.createdAt || 0);
    return bDate - aDate;
  });
}

export function formatAsOrdinal(i) {
  var j = i % 10,
      k = i % 100;
  if (j == 1 && k != 11) {
      return i + "st";
  }
  if (j == 2 && k != 12) {
      return i + "nd";
  }
  if (j == 3 && k != 13) {
      return i + "rd";
  }
  return i + "th";
}

export function containsNonAlpha(str){
  return !/^[a-z]+$/i.test(str);
}

export function isAdminUser(userType) {
  return userType === userTypes.DISTRICT_ADMIN || userType === userTypes.SCHOOL_ADMIN;
}

export function isBrowser() {
  // window.device is not always defined immediately on application launch on iOS.
  // This was moved from a constant in constants.js to a computed value in util.js so that it would only be accessed after the deviceready event in index.js.
  return !window.device || window.device.platform === 'browser'; // TODO: Move this to an env var
}

export function getSentryEnv(){
  if(!process.env.STACK) return "development"
  // To lower case to make sure we don't create a new production environment in sentry.
  return process.env.STACK.toLocaleLowerCase()
}

export function logSentryException(error, infoMessage, extraData) {
  // First, check if error is an Error object. If not, then create a new error with the infoMessage.
  // If using the infoMessage, check if the error objects passed in is a graphql type error and log that data in a breadcrumb
  if (infoMessage) {
    Sentry.addBreadcrumb({
      message: infoMessage,
      level: "error",
    });
  }

  if (extraData) {
    Sentry.addBreadcrumb({
      message: 'Extra data',
      level: "error",
      data: {
        ...extraData
      }
    });
  }

  if (error instanceof Error || (error && error.stack && error.message)) {
    Sentry.captureException(error);
  } else {
    if (error && error.errors) {
      const data = {
        graphqlErrors: JSON.stringify(error.errors),
      }

      if (error.data) {
        data.graphqlData = JSON.stringify(error.data);
      }

      Sentry.addBreadcrumb({
        message: 'GraphQL error',
        level: "error",
        data,
      });
    }
    
    Sentry.captureException(new Error(infoMessage || 'Unknown error'));
  }
}

export function isNullOrUndefined(value) {
  return value === null || value === undefined;
}

export function isNotNullOrUndefined(value) {
  return value !== null && value !== undefined;
}

/**
 * Checks wheether an email is valid
 * @param {string} email email to check
 * @returns {boolean} valid or not
 */
export function isValidEmail(email) {
  const regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
  return regex.test(String(email).toLowerCase());
}

export function getDefaultGSFWordBank() {
  return {
    "words": [
      {
        "word": "cat",
        "category": 1
      },
      {
        "word": "crab",
        "category": 1
      },
      {
        "word": "camel",
        "category": 1
      },
      {
        "word": "dog",
        "category": 1
      },
      {
        "word": "duck",
        "category": 1
      },
      {
        "word": "donkey",
        "category": 1
      },
      {
        "word": "cabinet",
        "category": 2
      },
      {
        "word": "couch",
        "category": 2
      },
      {
        "word": "counter",
        "category": 2
      },
      {
        "word": "desk",
        "category": 2
      },
      {
        "word": "drawer",
        "category": 2
      },
      {
        "word": "door",
        "category": 2
      }
    ],
    "categories": [
      {
        "id": 1,
        "description": "animals"
      },
      {
        "id": 2,
        "description": "furniture"
      }
    ]
  };
}

export function shouldForceHTML5Audio(){
  const version = device.getBrowserForSession().version;
  const isIOS16_4_or_newer = isiPad() && (versionCompare(version, "16.4.1") >= 0);
  const forceHTML5 = isIOS16_4_or_newer;
  return forceHTML5;
}

/**
 * Used to remove any <prosody>...</prosody> tags from a string
 * @param {string} string any string
 * @returns string without the prosody tags
 */
export function removeProsodyTags(string) {
  if (!string) return;

  const prosodyTagRegex = /<\/?prosody\b[^>]*>/g;
  return string.replace(prosodyTagRegex, "");
}

/**
 * Used to remove any <emphasis/> tags from a string
 * @param {string} string any string
 * @returns string without the break tags
 */
export function removeEmphasisTags(string) {
  if (!string) return;

  const breakTagRegex = /<\/?emphasis\b[^>]*>/g;
  return string.replace(breakTagRegex, "");
}

/**
 * Used to remove an opening <break/> tags from a string
 * @param {string} string any string
 * @returns string without the break tags
 */
export function removeOpeningBreakTag(string) {
  if (!string) return;

  // Match <break> tag only if it appears at the very beginning of the string
  const breakTagAtStartRegex = /^<break\b[^>]*>/;
  return string.replace(breakTagAtStartRegex, "");
}

export function removeOpeningEllipsis(string) {
  if (!string) return;

  // Match an ellipsis "..." only if it appears at the very beginning of the string
  const ellipsisAtStartRegex = /^\.\.\./;
  return string.replace(ellipsisAtStartRegex, "");
}
